import { render, staticRenderFns } from "./ChangeParent.vue?vue&type=template&id=c3ea1f66&"
import script from "./ChangeParent.vue?vue&type=script&lang=js&"
export * from "./ChangeParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports